export default "__VITE_ASSET__BLGdirzD__"